import type { IEmailData } from '../models';

export const generateEmailLinkHtml = async (payload: IEmailData): Promise<string> => {
  return payload.link;
};
